import { AsyncAction } from '..';
import { AsyncActionType } from './useAsync';

export function getAsyncAddItemPayload<T>(data: T[], item: T): AsyncAction<T[]> {
  return { type: AsyncActionType.SET_DATA, payload: { data: [...data, item] } };
}

export function getAsyncAddItemsPayload<T>(data: T[], item: T[]): AsyncAction<T[]> {
  return { type: AsyncActionType.SET_DATA, payload: { data: [...data, ...item] } };
}

export function getAsyncApplyPredicatePayload<T>(data: T[], predicate: (value: T) => boolean): AsyncAction<T[]> {
  return { type: AsyncActionType.SET_DATA, payload: { data: data.filter(predicate) } };
}

export function getAsyncApplyTransformPayload<T>(data: T[], transform: (value: T) => T): AsyncAction<T[]> {
  return { type: AsyncActionType.SET_DATA, payload: { data: data.map(transform) } };
}
